import React, { Component } from 'react';
import { EditorState, Compartment } from '@codemirror/state';
import { EditorView, keymap, drawSelection } from '@codemirror/view';
import { defaultKeymap, history, historyKeymap } from '@codemirror/commands';
import { markdown } from '@codemirror/lang-markdown';
import { syntaxHighlighting, defaultHighlightStyle } from '@codemirror/language';

const SYSTEM_FONT = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif";

class CodeMirrorEditor extends Component {
    constructor(props) {
        super(props);
        this.editorRef = React.createRef();
        this.view = null;
        this._ignoreUpdate = false;
        this.sizeCompartment = new Compartment();
    }

    buildTheme(fontSize) {
        const size = (fontSize || 12) + 'px';
        return EditorView.theme({
            '&': { height: '100%', minHeight: '0', fontSize: size },
            '.cm-scroller': { overflow: 'auto', lineHeight: '1.8', fontFamily: SYSTEM_FONT, height: '100%' },
            '.cm-content': {
                padding: '20px 24px',
                minHeight: '200px',
                caretColor: '#1890ff',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                fontFamily: SYSTEM_FONT,
                fontSize: size,
            },
            '.cm-line': { padding: '0', fontFamily: SYSTEM_FONT, fontSize: size },
            '.cm-focused': { outline: 'none' },
            '&.cm-focused .cm-cursor': { borderLeftColor: '#1890ff', borderLeftWidth: '2px' },
            '.cm-selectionBackground': { background: '#b3d4fd !important' },
            '&.cm-focused .cm-selectionBackground': { background: '#b3d4fd !important' },
        });
    }

    componentDidMount() {
        const state = EditorState.create({
            doc: this.props.value || '',
            extensions: [
                history(),
                drawSelection(),
                syntaxHighlighting(defaultHighlightStyle),
                markdown(),
                EditorView.lineWrapping,
                keymap.of([...defaultKeymap, ...historyKeymap]),
                this.sizeCompartment.of(this.buildTheme(this.props.fontSize)),
                EditorView.updateListener.of((update) => {
                    if (update.docChanged && !this._ignoreUpdate) {
                        if (this.props.onChange) {
                            this.props.onChange(update.state.doc.toString());
                        }
                    }
                }),
            ],
        });
        this.view = new EditorView({ state, parent: this.editorRef.current });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value && this.view) {
            const currentValue = this.view.state.doc.toString();
            if (currentValue !== this.props.value) {
                this._ignoreUpdate = true;
                this.view.dispatch({
                    changes: { from: 0, to: this.view.state.doc.length, insert: this.props.value || '' },
                });
                this._ignoreUpdate = false;
            }
        }
        if (prevProps.fontSize !== this.props.fontSize && this.view) {
            this.view.dispatch({
                effects: this.sizeCompartment.reconfigure(this.buildTheme(this.props.fontSize)),
            });
        }
    }

    componentWillUnmount() {
        if (this.view) { this.view.destroy(); this.view = null; }
    }

    render() {
        return <div ref={this.editorRef} style={{ border: '1px solid #f0f0f0', flex: 1, minHeight: 0, overflow: 'hidden' }} />;
    }
}

export default CodeMirrorEditor;

